import { IconSize, useLayoutContext, useScaleFactor, useTheme } from "arkh";

import { Feather } from "@expo/vector-icons";
import React from "react";

export const EmptyResult = ({
  size,
  absoluteSize,
}: {
  size?: IconSize;
  absoluteSize?: number;
}) => {
  const theme = useTheme();
  const layout = useLayoutContext();
  const sf = useScaleFactor();
  const resolvedSize = absoluteSize ?? layout.icon[size ?? "medium"] * sf;

  return (
    <Feather
      name="minus"
      size={resolvedSize}
      color={theme.negative}
      style={{ width: resolvedSize }}
    />
  );
};
